import React, {useEffect} from 'react'
import {GoogleMap, InfoWindow, Marker, useJsApiLoader} from '@react-google-maps/api';
import * as Common from "../CommonControlls/CommonJs";
import {connect} from "react-redux";

const containerStyle = {
    width: '100%',
    height: '800px'
}

const center = {
    lat: 33.65895189,
    lng: 73.0072405
};


const mapStateToProps = (store) => {
    return store
}

function MapComponent(props) {
    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAP_KEY
    })

    // const [map, setMap] = React.useState(null)
    const [data, setData] = React.useState(props.MapReducer.data)

    // const onLoad = React.useCallback(function callback(map) {
    //     const bounds = new window.google.maps.LatLngBounds(center);
    //     map.fitBounds(bounds);
    //     setMap(map)
    // }, [])
    //
    // const onUnmount = React.useCallback(function callback(map) {
    //     setMap(null)
    // }, [])

    const handleShowMarker = (event, id) => {
        const shallowCopy = [...data]
        setData(shallowCopy.map(item => {
            if(item.id === id) {
                return {
                    ...item,
                    showMarker: !item.showMarker
                }
            }
            return item
        }))
    }

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={6}
        >
            {data.map((item, index) => (
                <Marker key={item.id} label={''} onClick={e => handleShowMarker(e, item.id)} position={{lat: item.lat, lng: item.lng}} />
            ))}
            {data.map(item => (
                item.showMarker && <InfoWindow key={item.id} position={{lat: item.lat, lng: item.lng}}>
                    <div>
                        <h4 className="font-bold mb-2 ">{item.name}</h4>
                        <p><span className="font-bold">Samples Created: </span>{item.samplesCreated}</p>
                        <p><span className="font-bold">Completed Assignments: </span>{item.completedAssignments}</p>
                        <p><span className="font-bold">Samples Transported: </span>{item.samplesTransported}</p>
                    </div>
                </InfoWindow>
            ))}
        </GoogleMap>
    ) : <></>
}

export default connect(mapStateToProps)(MapComponent);
